import { WRTile } from "./tile";
import { v4 as uuidv4 } from 'uuid';

export class WRTopic
{
    id: string;
    title: string;
    text: string;
    tiles: Array<WRTile>;
    backend_expanded: boolean = false;

    constructor(title: string = "", text: string = "", tiles: Array<WRTile>, backend_expanded: boolean = false)
    {
        this.id = uuidv4();
        this.title = title;
        this.text = text;
        this.tiles = tiles;
        this.backend_expanded = backend_expanded;
    }
}
